import { render, staticRenderFns } from "./CorrespondentIndicated.vue?vue&type=template&id=29bddcda"
import script from "./CorrespondentIndicated.vue?vue&type=script&lang=js"
export * from "./CorrespondentIndicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports